import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_MEDREFILL_LOCATIONS_LIST_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetLocationListResult, GetPublicLocationListPayload } from '../types/getLocationList.type';

export const TAG_PUBLIC_MEDREFILL_LOCATION_LIST = 'getPublicLocationList';

export const getPublicLocationList = <T extends BuilderType>(builder: T) =>
  builder.query<GetLocationListResult, GetPublicLocationListPayload>({
    providesTags: [TAG_PUBLIC_MEDREFILL_LOCATION_LIST],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_PUBLIC_MEDREFILL_LOCATIONS_LIST_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetLocationListResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
